import { render, staticRenderFns } from "./modalConfPrecioProducto.vue?vue&type=template&id=6cbd9578"
import script from "./modalConfPrecioProducto.vue?vue&type=script&lang=js"
export * from "./modalConfPrecioProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports